import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, serviceConstants, zipapiURL, formOptions } from '../constants/service.constants';
import { City, ZipResponse, ZipData, Menu, ModuleFeatureModel, dropdownsource, ScreenModel, SCREEN_CONTROL, Document_Upload_File } from 'src/app/models/common';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { catchError, map, retry, switchMap, tap } from 'rxjs/operators';
import { IST_APP, EAP_APP, GM_APP } from 'src/app/models/common';
import { ModuleMenu } from 'src/app/models/common';
import { Organization } from 'src/app/models/um/organization';
import { SuccessBanertemplateComponent } from '../common/success-banertemplate/success-banertemplate.component';
import { ErrorbannerComponent } from '../common/errorbanner/errorbanner.component';
import { UserService } from './user.service';
import { MessageBoxComponent } from '../common/message-box/message-box.component';
import { DeleteBoxComponent } from '../common/delete-box/delete-box.component';
import { ConfirmationBoxComponent } from '../common/confirmation-box/confirmation-box.component';
import { IstSummaryService } from './ist/ist-summary.service';
import { HeadService } from './common/headservice';
import { Router } from '@angular/router';
import { IstDataShareService } from './ist/ist-datashare.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsDatashareService } from './grants/grants-datashare.service';
import { OnlineEditorComponentimplements } from '../common/online-editor/online-editor.component';
import { EditorType, UserEditConfig, UserEditorConfig } from '../constants/only-office-config';
import { AesEncriptionDecriptionService } from './common/aes-encription-decription.service';
import { ReviewService } from './common/review.service';
import { DatePipe } from '@angular/common';
import { UserPreferenceColumnsList } from '../common/columns-selection-popup/columns-selection-popup.component';
import { EAPDatashareService } from './eap/eap-datashare.service';
import { FileService } from './file.service';
@Injectable({
  providedIn: 'root'
})

export class CommonService {

  zipresponse: ZipResponse;
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  appId: string;
  ScreenID: string;
  leftmenus: Menu[] = [];
  topmenus: Menu[] = [];
  objcity: Observable<City>;
  menu: ModuleMenu;
  orgs: Organization[] = [];
  menudata: ModuleMenu;
  config: any = null;
  myDate = new Date();

  constructor(private http: HttpClient,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    private userService: UserService,
    private summaryService: IstSummaryService,
    private header: HeadService,
    private router: Router,
    private dataShare: IstDataShareService,
    private eapdataShare: EAPDatashareService,
    private GrantsShare: GrantsDatashareService,
    private securityService: AesEncriptionDecriptionService,
    public fileService: FileService
  ) {

  }

  isAutocodeConfigured(featureid: string, orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/isautoconfigured/' + featureid + '/' + orgid, httpOptions)
  }
  activeFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/active/' + table + '/' + id, httpOptions)
  }

  inactiveFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/inactive/' + table + '/' + id, httpOptions)
  }

  checkMandatoryFormFileds(appid: string, action: string, module: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/checkmandatory/' + appid + '/' + action + '/' + module, formOptions)
  }

  updateMandatoryFormFileds(appid: string, action: string, module: string, featurecode: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/UpadteManadotory/' + appid + '/' + action + '/' + module + '/' + featurecode, httpOptions)
  }

  getMenu(model: ModuleFeatureModel): Observable<Menu[]> {
    return this.http.post<Menu[]>(serviceConstants.apiURL + 'api/common/getmodulefeatures', model, httpOptions)
  }


  getModulesList(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/common/getmodules", httpOptions);
  }
  aplTypesList(moduleId: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/apptypes/getallapp?moduleId=" + moduleId, httpOptions);
  }

  getAllApplicationTypes(moduleId: string, subModule: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/apptypes/getallapp/" + moduleId + '/' + subModule, httpOptions);
  }

  getAllApplicationTypesforSearch(moduleId: string, subModule: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/apptypes/getallappforsearch/" + moduleId + '/' + subModule, httpOptions);
  }
  getAppTypesSpecificScreens(url: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/common/getzipinfo/' + zip, httpOptions);

    ////let url = zipapiURL.replace("@zipcode@", zip);
    //let url = serviceConstants.apiURL + 'api/common/getzipinfo/' + zip;
    //return this.http.get<ZipResponse>(url).pipe(
    //  tap( // Check the Valid request
    //    data => {

    //    },
    //    error => {

    //    }
    //  )
    //);
  }


  getRegCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/appuser/getzipinfo/' + zip, httpOptions);
  }
  GetWorkFlowlaunchingScreen(applicationID, applicationTypeID): Observable<any> { //orgId:any
    return this.http.get(serviceConstants.apiURL + 'api/common/GetWorkFlowlaunchingScreen?applicationID=' + applicationID + "&applicationTypeID=" + applicationTypeID, httpOptions);
  }

  getCurrentVersion(): Observable<any> { //orgId:any
    return this.http.get(serviceConstants.apiURL + 'api/appuser/fetchiegbuildversion', httpOptions);
  }

  getNotificationCount(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Notifications/NotificationCount', httpOptions);
  }
  GetChangeLogInfo(appId: string, module_id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getchangelogInfo/' + appId + "/" + module_id, httpOptions);
  }
  setModluleMenu(menu: ModuleMenu) {
    this.menu = menu;
    let encriptedStr = this.securityService.encryptionAES(JSON.stringify(this.menu));
    localStorage.setItem('3AUBD6Gd6T_menu', encriptedStr);
  }

  getModuleMenu() {
    if (this.menu === null || this.menu === undefined) {
      let decriptedApp = this.securityService.decryptionAES(localStorage.getItem("3AUBD6Gd6T_menu"));
      this.menu = JSON.parse(decriptedApp);
    }
    return this.menu;
  }
  getModuleName() {
    let name = "";
    let menus = this.getModuleMenu();
    if (menus != undefined && menus != null) {
      name = menus.module;
    }
    return name;

  }
  removeModuleMenu() {
    localStorage.setItem('3AUBD6Gd6T_menu', null);
    this.menu = null;
  }

  getEAPApp() {
    if (this.eapapp === null || this.eapapp === undefined) {
      this.eapapp = JSON.parse(localStorage.getItem("eapapp"));
    }
    return this.eapapp;
  }
  setEAPApp(app) {
    this.eapapp = app;
    localStorage.setItem('eapapp', JSON.stringify(app));
  }
  removeEAPApp() {
    this.eapapp = null;
    localStorage.setItem('eapapp', null);
  }



  getISTApp() {
    if (this.istapp === null || this.istapp === undefined) {
      let decriptedApp = this.securityService.decryptionAES(localStorage.getItem("ist_CPU10sfbxi_app"));
      if (decriptedApp == "null") {
        this.istapp = null;
      }
      else {
        this.istapp = JSON.parse(decriptedApp);
      }
    }
    return this.istapp;
  }
  removeISTApp() {
    this.istapp = null;
    localStorage.setItem('it_CPU10sfbxi_app', null);
  }
  setISTApp(app) {
    this.istapp = app;
    let encriptedStr = this.securityService.encryptionAES(JSON.stringify(this.istapp));
    localStorage.setItem('it_CPU10sfbxi_app', encriptedStr);
  }


  getIstStatus(): boolean {
    let IsSubmitRequired = false;
    this.istapp = this.getISTApp();
    if (this.istapp != null) {
      IsSubmitRequired = this.istapp.STATUS == 1 ? false : true;
    } else {
      IsSubmitRequired = false;
    }
    return IsSubmitRequired;
  }

  getEAPStatus(): boolean {
    let IsSubmitRequired = false;
    this.eapapp = this.getEAPApp();
    if (this.eapapp != null) {
      IsSubmitRequired = this.eapapp.STATUS == 1 ? false : true;
    } else {
      IsSubmitRequired = false;
    }
    return IsSubmitRequired;
  }


  setGrantsApp(app) {
    this.grantsapp = app;
    let encriptedStr = this.securityService.encryptionAES(JSON.stringify(this.grantsapp));
    localStorage.setItem('grt_1ptM4xo4pX_app', encriptedStr);
  }
  removeGrantsApp() {
    this.grantsapp = null;
    localStorage.setItem('grt_1ptM4xo4pX_app', null);
  }
  getGrantsApp() {
    if (this.grantsapp === null || this.grantsapp === undefined) {
      let decriptedApp = this.securityService.decryptionAES(localStorage.getItem("grt_1ptM4xo4pX_app"));
      if (decriptedApp == "null") {
        this.grantsapp = null;
      }
      else {
        this.grantsapp = JSON.parse(JSON.stringify(decriptedApp));
      }
    }
    return this.grantsapp;
  }
  getGrantsStatus(): number {
    this.grantsapp = this.getGrantsApp();
    return this.grantsapp != null ? this.grantsapp.STATUS : null;
  }
  setLeftMenu(menus: Menu[]) {
    this.leftmenus = menus;
    let encriptedStr = this.securityService.encryptionAES(JSON.stringify(this.leftmenus));
    localStorage.setItem("left_z9v2CpJ8qI", encriptedStr);
  }
  removeLeftMenu() {
    this.leftmenus = [];
    localStorage.setItem("left_z9v2CpJ8qI", null);
  }
  getLeftMenu() {
    if (this.leftmenus === null || this.leftmenus === undefined) {
      let decriptedApp = this.securityService.decryptionAES(localStorage.getItem("left_z9v2CpJ8qI"));
      this.leftmenus = JSON.parse(decriptedApp);
    }
    return this.leftmenus;
  }

  getPagePermission(pagecode: string) {
    let permission = "";
    if (this.leftmenus === null || this.leftmenus === undefined) {
      this.leftmenus = this.getLeftMenu();
    }

    if (this.leftmenus !== null && this.leftmenus !== undefined) {
      const len = this.leftmenus.length;
      for (let iCount = 0; iCount < len; iCount++) {
        if (this.leftmenus[iCount].Code == pagecode) {
          permission = this.leftmenus[iCount].Operation;
          break;
        }
      }
    }
    if (permission === "") {
      if (this.topmenus === null || this.topmenus === undefined) {
        this.topmenus = this.getTopMenu();
      }

      if (this.topmenus !== null && this.topmenus !== undefined) {
        const len = this.topmenus.length;
        for (let iCount = 0; iCount < len; iCount++) {
          if (this.topmenus[iCount].Code == pagecode) {
            permission = this.topmenus[iCount].Operation;
            break;
          }
        }
      }
    }
    return permission;
  }

  setTopMenu(menus: Menu[]) {
    this.topmenus = menus;
    let encriptedStr = this.securityService.encryptionAES(JSON.stringify(this.topmenus))
    localStorage.setItem("top_Us4Kp7Thux_m", encriptedStr);
  }

  getTopMenu() {
    if (this.topmenus === null || this.topmenus === undefined) {
      let decriptedStr = this.securityService.decryptionAES(localStorage.getItem("top_Us4Kp7Thux_m"))
      this.topmenus = JSON.parse(decriptedStr);
    }
    return this.topmenus;
  }

  getScreenPermission(pagecode: string, Operation: string) {
    let IsHadPermission = false;
    let UserData = this.userService.getUserDetais()
    if (UserData != null && UserData != undefined) {
      UserData.FEATURES.forEach(element => {
        var isScreenExits = element.Features.filter(function (item) {
          return item.Code == pagecode;
        })[0];
        if (isScreenExits != undefined && isScreenExits != null) {
          if (isScreenExits.OperationMapped.indexOf(Operation) > -1) {
            IsHadPermission = true;
          }
        }
      });
    }
    return IsHadPermission;
  }

  getModuleId(module: string): string {
    let modid = "";
    switch (module) {
      case "ist":
        modid = "2";
        break;
      case "eap":
        modid = "5";
        break;
      case "grantscme":
      case "grants":
        modid = "4";
        break;
      case "grantssponsership":
        modid = "3";
        break;
      case "grantscharitable":
        modid = "7";
        break;
    }

    return modid;
  }

  getLocalOrgObject(): any {
    if (localStorage.getItem("G7k8VfmWzR_org") != null && localStorage.getItem("G7k8VfmWzR_org") != undefined) {
      let encriptedStr = this.securityService.decryptionAES(localStorage.getItem("G7k8VfmWzR_org"));
      return encriptedStr;
    }
    else {
      return null;
    }

  }

  setOrganizations(orgs) {
    if (orgs == null) {
      localStorage.setItem("G7k8VfmWzR_org", null);
    }
    else {
      this.orgs = orgs;
      let encriptedStr = this.securityService.encryptionAES(JSON.stringify(orgs))
      localStorage.setItem("G7k8VfmWzR_org", encriptedStr);

    }
  }

  setlocalStorageUserDetails(UserDetails: any) {
    let encriptedStr = this.securityService.encryptionAES(UserDetails);
    localStorage.setItem("uds", encriptedStr);
  }
  getlocalStorageUserDetails() {
    return this.securityService.decryptionAES(localStorage.getItem("uds"));
  }

  getOrganizationName(code: string): string {
    let orgname = "";
    let orgId = "";

    if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(this.getLocalOrgObject());
    }
    if (this.orgs === null || this.orgs === undefined)
      return "";
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          orgname = this.orgs[i].NAME
          break;
        }
      }
      return orgname;
    }
  }

  getOrgDetails(): any {
    return JSON.parse(this.getLocalOrgObject());
  }
  getOrganizationObject(code: string): Organization {
    let org = null;
    if (code != null && code != undefined) {
      this.orgs = JSON.parse(this.getLocalOrgObject());

      if (this.orgs === null || this.orgs === undefined)
        return null;
      else {
        const count = this.orgs.length;
        for (let i = 0; i < count; i++) {
          if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
            org = this.orgs[i]
            break;
          }
        }
        return org;
      }
    }

  }



  getStatus(statusnum: number): string {
    let status = "";
    return status;
  }

  getUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  ValidationBanner(Message: any) {
    const Modalref = this.modalService.open(MessageBoxComponent,
      { backdrop: false, }
    );
    Modalref.componentInstance.Content = { heading: 'Validation Message(s)', content: { heading: '', description: Message } };
  }
  InformationBanner(Message: any) {
    const modalref = this.modalService.open(MessageBoxComponent,
      { backdrop: false, }
    );
    modalref.componentInstance.Content = { heading: 'Information Message(s)', content: { heading: '', description: Message } };
    return modalref.result;
  }
  CanDeactivateBanner() {
    const modalRef = this.modalService.open(ConfirmationBoxComponent, { backdrop: false })
    modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'There are some unsaved changes. Do you want to continue?', ProceedButtonName: "Ok", TerminateButtonName: "Cancel" };
    return modalRef.result;
  }
  SuccessBanner(Message: string) {
    const Modalref = this.modalService.open(SuccessBanertemplateComponent,
      {
        windowClass: 'sccsessMessage'
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }
  ErrorBanner(Message: string) {
    const Modalref = this.modalService.open(ErrorbannerComponent,
      {
        windowClass: 'lg ErrorMessage',
        backdrop: false,
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }

  getdisplayedDate(date: string): Date {
    if (date == null || date == undefined || date == "") {
      return null;
    }
    else {
      return new Date(date.replace('Z', ''));
    }
  }

  previewFile(fileid: string, filename: string, type: string) {
    if (!filename) {
      return false;
    }
    let disallowedExtensions: string[] = [
      'pptx', 'ppt', 'jpg', 'jpeg', 'png', 'pdf', 'txt',
      'doc', 'docx', 'xls', 'xlsx', 'mov', 'mp4', 'mp3', 'avi'
    ];
    const extension = filename.split('.').pop()?.toLowerCase();
    if (!disallowedExtensions.includes(extension)) {
      this.ValidationBanner("The file cannot be previewed in the system. Please download to view it.");
    }
    else {
      let encodedFileName = btoa(filename);
      let expandEmailURL = serviceConstants.baseUrl + "/filepreview/" + fileid + "/" + type + "/" + encodedFileName
      window.open(`${expandEmailURL}`, 'Reference Document', 'width=800, height=500');
    }

  }

  validateEmail(email: string): boolean {
    const regularExpression = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    return regularExpression.test(String(email));
  }

  refreshApplicationPage(applicationID: any, Moduleid: any, applicationType: any = "", Target: string = "my") {
    if (applicationID) {
      // this.router.navigate(['/home']).then(() => {
      switch (Moduleid) {
        case "ist":
          this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
            this.istapp = data;
            this.appId = data.ID;
            this.ScreenID = data.ID;
            this.setISTApp(this.istapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = "IST";
            this.menudata.operation = "Edit";
            this.menudata.appId = this.istapp.ID;
            this.menudata.screenID = this.istapp.ID;
            this.menudata.TargetFrom = Target;
            if (this.istapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.istapp.CurrentStatusExt;

            this.setModluleMenu(this.menudata);
            this.header.setHeader(this.menudata);
            this.dataShare.setApplicationID(data["ID"]);
            if (Target == "my") {
              let URL = "/home/ist/my-applications/application-ext/:" + data['ID'] + "/" + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications", IsOnlyView: false } })
            }
            else {
              let URL = "/home/ist/applications/application-ext/:" + data['ID'] + "/" + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "applications", IsOnlyView: true } })
            }
          });
          break;
        case "eap":
          this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
            this.removeLeftMenu();
            this.eapapp = data;
            this.appId = data.ID;
            this.setEAPApp(this.eapapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = "EAP";
            this.menudata.operation = "Edit";
            this.menudata.appId = this.eapapp.ID;
            this.menudata.screenID = this.eapapp.ID;
            this.menudata.TargetFrom = Target;
            if (this.eapapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.getStatus(this.eapapp.STATUS);
            this.setModluleMenu(this.menudata);

            this.header.setHeader(this.menudata);
            this.eapdataShare.setApplicationID(data["ID"]);

            if (Target == "my") {
              let URL = "/home/eap/my-applications/application-ext/:" + data['ID'] + "/" + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications", IsOnlyView: false } })
            }
            else {
              let URL = "/home/eap/applications/application-ext/:" + data['ID'] + "/" + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "applications", IsOnlyView: true } })
            }

          });
          break;
        case "grants":
          let RecordID = "";
          this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
            this.removeLeftMenu();
            let modulecode = "";
            this.grantsapp = data;
            this.appId = this.grantsapp.ID;
            this.setGrantsApp(this.grantsapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = modulecode;
            this.menudata.operation = "Edit";
            this.menudata.appId = this.grantsapp.ID;
            this.menudata.screenID = this.grantsapp.ID;
            this.menudata.TargetFrom = Target;
            if (this.grantsapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.getStatus(this.grantsapp.STATUS);

            this.GrantsShare.setGrantApplicationID(applicationID);

            if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCME") {
              modulecode = "GRANTSCME";
              this.GrantsShare.CMEID.subscribe((x) => {
                RecordID = x;
                this.menudata.module = modulecode;
                this.removeLeftMenu();
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                if (Target == "my") {
                  let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })
                }
                else {
                  let URL = "/home/grants/applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "applications", IsOnlyView: true } })
                }
              });
            }
            else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSSPONSORSHIP") {
              modulecode = "GRANTSSPONSORSHIP";
              this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
                RecordID = x;
                this.removeLeftMenu();
                this.menudata.module = modulecode;
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                if (Target == "my") {
                  let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })
                }
                else {
                  let URL = "/home/grants/applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "applications", IsOnlyView: true } })
                }
              })
            }
            else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCHARITABLE") {
              modulecode = "GRANTSCHARITABLE";
              this.GrantsShare.CharityID.subscribe((x) => {
                RecordID = x;
                this.removeLeftMenu();
                this.menudata.module = modulecode;
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                if (Target == "my") {
                  let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })
                }
                else {
                  let URL = "/home/grants/applications/application-ext/:" + applicationID + "/" + data.FLEX_FIELD_1;
                  this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "applications", IsOnlyView: true } })
                }
              })
            }
          });

          break;
      }
      //});
    }
    else {
      this.LaunchingFirstScreen(Moduleid, applicationType);
    }

  }
  LaunchingFirstScreen(Moduleid: string, applicationType: string) {
    switch (Moduleid) {
      case "ist":
        this.GetWorkFlowlaunchingScreen("", applicationType).subscribe((summay) => {
          this.removeLeftMenu();
          this.header.setHeader(null);
          this.dataShare.setApplicationID("");
          this.appId = "";
          this.ScreenID = "";
          this.setISTApp(null);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "New";
          this.menudata.appId = "-1";
          this.menudata.formstate = "Draft";
          this.menudata.screenID = "";
          this.setModluleMenu(this.menudata);
          this.header.setHeader(this.menudata);
          let URL = "/home/ist/my-applications/application-ext/:0/" + summay.Data;
          this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: "", app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications", ApplicationType: applicationType, IsOnlyView: false } })
        });
        break;
      case "eap":
        this.GetWorkFlowlaunchingScreen("", applicationType).subscribe((summay) => {
          this.header.setHeader(null);
          this.removeLeftMenu();
          this.eapdataShare.setApplicationID("");
          this.appId = "";
          this.ScreenID = "";
          this.setEAPApp(null);
          this.menudata = new ModuleMenu();
          this.menudata.module = "EAP";
          this.menudata.operation = "New";
          this.menudata.appId = "-1";
          this.menudata.formstate = "Draft";
          this.menudata.screenID = "";
          this.setModluleMenu(this.menudata);
          this.header.setHeader(this.menudata);
          let URL = "/home/eap/my-applications/application-ext/:0/" + summay.Data;
          this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: "", app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications", ApplicationType: applicationType, IsOnlyView: false } })
        });
        break;
      case "grants":
        this.GetWorkFlowlaunchingScreen("", applicationType).subscribe((summay) => {
          this.header.setHeader(null);
          this.removeLeftMenu();
          this.ScreenID = "";
          this.appId = "";
          this.setGrantsApp(null);
          this.menudata = new ModuleMenu();
          let modulecode = "";
          this.GrantsShare.setCMEID("");
          this.GrantsShare.setSPONSORSHIPID("");
          this.GrantsShare.setCharityID("");
          this.menudata.module = "";
          this.menudata.operation = "New";
          this.menudata.appId = "-1";
          this.menudata.formstate = "Draft";

          this.GrantsShare.setGrantApplicationID("");
          if (summay.TransactionCode.toLowerCase() === "cme") {
            modulecode = "GRANTSCME";
            this.menudata.module = "GRANTSCME";
          }
          else if (summay.TransactionCode.toLowerCase() === "sponsorship") {
            this.menudata.module = modulecode = "GRANTSSPONSORSHIP";

          }
          else if (summay.TransactionCode.toLowerCase() === "charitable") {
            this.menudata.module = modulecode = "GRANTSCHARITABLE";
          }
          this.setModluleMenu(this.menudata);
          this.header.setHeader(this.menudata);
          let URL = "/home/grants/my-applications/application-ext/:0/" + summay.Data;
          this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: 0, app_ext: true, screen_type: "my-applications", ApplicationType: applicationType, IsOnlyView: false } })

        });

        break;
    }
  }

  LaunchingRequiredScreen(applicationID: any, Moduleid: any,NavigationScreen="") {
    if (applicationID) {
      switch (Moduleid) {
        case "ist":
          this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
            this.istapp = data;
            this.appId = data.ID;
            this.ScreenID = data.ID;
            this.setISTApp(this.istapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = "IST";
            this.menudata.operation = "Edit";
            this.menudata.appId = this.istapp.ID;
            this.menudata.screenID = this.istapp.ID;
            this.menudata.TargetFrom = "my";
            if (this.istapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.istapp.CurrentStatusExt;

            this.setModluleMenu(this.menudata);
            this.header.setHeader(this.menudata);
            this.dataShare.setApplicationID(data["ID"]);
            let URL = "/home/ist/my-applications/application-ext/:" + data['ID'] + "/" + NavigationScreen;
            this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications", IsOnlyView: false } })
          });
          break;
        case "eap":
          this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
            this.removeLeftMenu();
            this.eapapp = data;
            this.appId = data.ID;
            this.setEAPApp(this.eapapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = "EAP";
            this.menudata.operation = "Edit";
            this.menudata.appId = this.eapapp.ID;
            this.menudata.screenID = this.eapapp.ID;
            this.menudata.TargetFrom = "my";
            if (this.eapapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.getStatus(this.eapapp.STATUS);
            this.setModluleMenu(this.menudata);
            this.header.setHeader(this.menudata);
            this.eapdataShare.setApplicationID(data["ID"]);
            let URL = "/home/eap/my-applications/application-ext/:" + data['ID'] + "/" + NavigationScreen;
            this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications", IsOnlyView: false } })
           
          });
          break;
        case "grants":
          let RecordID = "";
          this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
            this.removeLeftMenu();
            let modulecode = "";
            this.grantsapp = data;
            this.appId = this.grantsapp.ID;
            this.setGrantsApp(this.grantsapp);
            this.menudata = new ModuleMenu();
            this.menudata.module = modulecode;
            this.menudata.operation = "Edit";
            this.menudata.appId = this.grantsapp.ID;
            this.menudata.screenID = this.grantsapp.ID;
              this.menudata.TargetFrom = "my";
            if (this.grantsapp.STATUS === null)
              this.menudata.formstate = "Draft";
            else
              this.menudata.formstate = this.getStatus(this.grantsapp.STATUS);

            this.GrantsShare.setGrantApplicationID(applicationID);

            if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCME") {
              modulecode = "GRANTSCME";
              this.GrantsShare.CMEID.subscribe((x) => {
                RecordID = x;
                this.menudata.module = modulecode;
                this.removeLeftMenu();
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + NavigationScreen;
                this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })
              });
            }
            else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSSPONSORSHIP") {
              modulecode = "GRANTSSPONSORSHIP";
              this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
                RecordID = x;
                this.removeLeftMenu();
                this.menudata.module = modulecode;
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + NavigationScreen;
                 this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })

              })
            }
            else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCHARITABLE") {
              modulecode = "GRANTSCHARITABLE";
              this.GrantsShare.CharityID.subscribe((x) => {
                RecordID = x;
                this.removeLeftMenu();
                this.menudata.module = modulecode;
                this.setModluleMenu(this.menudata);
                this.header.setHeader(this.menudata);
                let URL = "/home/grants/my-applications/application-ext/:" + applicationID + "/" + NavigationScreen;
                this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: false } })
              })
            }
          });

          break;
      }
    }
  }

  ViewApplicationPage(applicationID: any, Moduleid: any, subModuleID: any) {
    switch (Moduleid) {
      case "ist":
        this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
          this.istapp = data;
          this.appId = data.ID;
          this.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          this.menudata.TargetFrom = 'all';
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.istapp.CurrentStatusExt;
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          let URL = '/home/ist/my-applications/application-ext/:' + data['ID'] + '/' + data.FLEX_FIELD_1;
          this.router.navigate([URL], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications", IsOnlyView: true } })
        });
        break;
      case "eap":
        this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          this.eapapp = data;
          this.appId = data.ID;
          this.setEAPApp(this.eapapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "EAP";
          this.menudata.operation = "Edit";
          this.menudata.TargetFrom = 'all';
          this.menudata.appId = this.eapapp.ID;
          if (this.eapapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.eapapp.CurrentStatusExt;

          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.eapdataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/eap/my-applications/application-ext/:' + data['ID'] + data.FLEX_FIELD_1], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications", IsOnlyView: true } })
        });
        break;
      case "grants":
        let RecordID = "";
        this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          let modulecode = "";
          this.grantsapp = data;
          this.appId = this.grantsapp.ID;
          this.setGrantsApp(this.grantsapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = modulecode;
          this.menudata.TargetFrom = 'all';
          this.menudata.operation = "Edit";
          this.menudata.appId = this.grantsapp.ID;
          if (this.grantsapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.grantsapp.CurrentStatusExt;

          this.GrantsShare.setGrantApplicationID(applicationID);

          if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCME") {
            modulecode = "GRANTSCME";
            this.GrantsShare.CMEID.subscribe((x) => {
              RecordID = x;
              this.menudata.module = modulecode;
              this.removeLeftMenu();
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              let URL = '/home/grants/my-applications/application-ext/:' + applicationID + '/' + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: true } })

            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSSPONSORSHIP") {
            modulecode = "GRANTSSPONSORSHIP";
            this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              let URL = '/home/grants/my-applications/application-ext/:' + applicationID + '/' + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: true } })
            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCHARITABLE") {
            modulecode = "GRANTSCHARITABLE";
            this.GrantsShare.CharityID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              let URL = '/home/grants/my-applications/application-ext/:' + applicationID + '/' + data.FLEX_FIELD_1;
              this.router.navigate([URL], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications", IsOnlyView: true } })
            })
          }

        });

        break;
    }

  }


  getScreenStaticFields(screenCode: string, AppID: string) {
    return this.http.get(serviceConstants.apiURL + `api/screen/StaticControlsData?ScreenID=${screenCode}&AppID=${AppID}`, httpOptions);
  }
  public readonly keepAliveSession$ = timer(1000, 15 * 60 * 1000).pipe(
    tap(_ => console.trace("Session KeepAlive called for integrated services.")),
    switchMap(_ => this.http.get(serviceConstants.apiURL + 'api/Review/KeepAlive').pipe(retry(1)))
  );

  createDocEditorConfig(config: Partial<UserEditorConfig>): Observable<any> {
    return this.http.post<UserEditConfig>(serviceConstants.apiURL + 'api/Review/CreateDocEditorConfig', config, httpOptions);
  }

  getRegistratinConfiguredFiledsData(id: string, module: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + `api/RegistrationConfig/RegistrationControlsData?id=${id}&module=${module}`, httpOptions);
  }

  OnlyOfficePopupLanch(ReviewDocID, ReviwID, ReviewDocs: any = null, ApplicationCode: string = null, IsOwner: boolean): Observable<any> {
    const editorConfig: Partial<UserEditorConfig> = {
      CanEdit: false,
      CanReview: true,
      IsEditMode: false,
      FileID: ReviewDocID,
      ReviewID: ReviwID,
      IsOwner: IsOwner,
    };
    return this.createDocEditorConfig(editorConfig).pipe(switchMap((x) => this.OnlyOfficePopupLanchReturn(x, ReviewDocID, ReviwID, ApplicationCode, ReviewDocs)));
  }
  OnlyOfficePopupLanchReturn(result, ReviewDocID, ReviwID, ApplicationCode, ReviewDocs): Promise<any> {
    let options = {
      backdrop: false,
      windowClass: 'modal-xxl right modal-right',
    };
    if (result != null && result != undefined) {
      this.config = result;
      const modalRef = this.modalService.open(OnlineEditorComponentimplements, options)
      modalRef.componentInstance.config = result;
      if (result.IsOwner == true) {
        modalRef.componentInstance.editorType = EditorType.ReviewOwner;
      } else {
        modalRef.componentInstance.editorType = EditorType.FreeEdit;
        // this.CompleteReviewDocStatus(this.config.UserConfigID,  ReviwID);
      }
      if (result.FileType == "docx" || result.FileType == "doc") {
        modalRef.componentInstance.formateType = "docx";
        modalRef.componentInstance.documentType = "word";
      } else {
        modalRef.componentInstance.formateType = "pptx";
        modalRef.componentInstance.documentType = "slide";
      }
      modalRef.componentInstance.Content = {
        ReviwID: ReviwID,
        FileID: ReviewDocID,
        ReviewDocs: ReviewDocs,
        ApplicationCode: ApplicationCode
      };
      return modalRef.result;
    }
  }


  CheckIsFileIsRefereancedInReviw(fileID: string) {
    return this.http.get(serviceConstants.apiURL + `api/common/CheckIsFileIsRefereancedInReviw?FileID=${fileID}`, httpOptions);
  }

  CompleteReviewDocStatus(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
    // return this.http.get("api/Review/ReviewDocUniqueKey?ConfigId=" +ConfigId + '&ReviewId=' + ReviewId,  httpOptions);
  }

  GetColumns(moduleId: string, isAllApplications: boolean) {
    return this.http.get(serviceConstants.apiURL + `api/common/GetColumns/${moduleId}/${isAllApplications}`, httpOptions);
  }

  SaveUserPreferencesColumns(userPreferencesJson: string) {
    return this.http.post<string>(serviceConstants.apiURL + `api/common/SaveUserPreferencesColumns`, userPreferencesJson, httpOptions);
  }

  GetUserPreferencesColumns() {
    return this.http.get<UserPreferenceColumnsList>(serviceConstants.apiURL + `api/common/GetUserPreferencesColumns`, httpOptions);
  }


  private stopDirty: BehaviorSubject<boolean> = new BehaviorSubject(false);
  makedirty = this.stopDirty.asObservable();
  getGlobalDirtyInfo(): any {
    return this.stopDirty.asObservable();
  }

  setGlobalDirtyInfo(setdirty: boolean) {
    this.stopDirty.next(setdirty);
  }



  GetScreenConfigControls(screenCode: string, AppID: string, RecordGuid: string = '', callback: (response: any) => void): any {
    this.http.get(serviceConstants.apiURL + `api/screen/GetScreenConfigControls?ScreenID=${screenCode}&AppID=${AppID}&RecordGuid=${RecordGuid}`, httpOptions).subscribe(summary => {
      let screencontrols: any = summary;
      if (screencontrols != null && screencontrols.SCREEN_CONTROL.length > 0) {
        for (var i = 0; i < screencontrols.SCREEN_CONTROL.length; i++) {
          switch (screencontrols.SCREEN_CONTROL[i].CONTROL) {
            case 1:
            case 2:
            case 3:
            case 9:
            case 11:
              screencontrols.SCREEN_CONTROL[i].ControlValue = "";
              break;
            case 8:
              screencontrols.SCREEN_CONTROL[i].UploadFiles = [];
              break;
            case 5:
              const now = new Date();
              let formd = "";
              formd = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
              screencontrols.SCREEN_CONTROL[i].ControlValue = null;

              if (!screencontrols.SCREEN_CONTROL[i].IS_PASTDATES_ALLOWED) {
                if (screencontrols.SCREEN_CONTROL[i].DATEFORMATE == 'YYYY') {
                  this.myDate = new Date();
                  screencontrols.SCREEN_CONTROL[i].minDat = new Date(this.myDate.getFullYear(), 0, 1);  // January 1st of the current year
                }
                else {
                  screencontrols.SCREEN_CONTROL[i].minDat = new Date();
                }
                screencontrols.SCREEN_CONTROL[i].minDat.setHours(0, 0, 0, 0);
              }
              else {
                screencontrols.SCREEN_CONTROL[i].minDat = null;
              }
              break;
            case 4:
            case 6:
            case 7:
            case 10:
              screencontrols.SCREEN_CONTROL[i].ControlValue = "";
              let sourceitems: dropdownsource[] = [];
              var options = screencontrols.SCREEN_CONTROL[i].GROUP_VALUES_LIST;
              if (options && options.length > 0) {
                for (var iOpt = 0; iOpt < options.length; iOpt++) {
                  if (options[iOpt] != null && options[iOpt] != "") {
                    let sourceitem = new dropdownsource();
                    sourceitem.label = options[iOpt]["label"];
                    sourceitem.value = options[iOpt]["value"];
                    sourceitems.push(sourceitem);
                  }
                }
                if (screencontrols.SCREEN_CONTROL[i].CONTROL == "4") {
                  let tempList = [];
                  let sourceitems1 = new dropdownsource();
                  sourceitems1.label = "Select";
                  sourceitems1.value = "";
                  tempList.push(sourceitems1);
                  sourceitems = tempList.concat(sourceitems);

                }

                screencontrols.SCREEN_CONTROL[i].SourceItems = [];
                screencontrols.SCREEN_CONTROL[i].SourceItems = sourceitems;
              }
              if (screencontrols.SCREEN_CONTROL[i].CONTROL == 4) {

                screencontrols = this.UpdateParentChildDetails(screencontrols, screencontrols.SCREEN_CONTROL[i]);
              }
              break;
          }
        }
      }
      return callback(screencontrols);
    });
  }


  UpdateParentChildDetails(screencontrols: any, question: SCREEN_CONTROL): any {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            //displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            //enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            //hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            //disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    screencontrols.SCREEN_CONTROL.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });
    return screencontrols;
  }


  isAllowedExtension(filename: string): boolean {
    // if (!filename) {
    //   return false;
    // }
    // let disallowedExtensions: string[] = [
    //   'wmv', 'flv', 'mkv', 'webm', 'mpg', 'mpeg', 'mpe',
    //   '3gp', '3g2', 'avchd', 'ogv', 'ogg', 'gifv', 'wav', 'aiff', 'aif', 'flac',
    //   'm4a', 'wma', 'aac', 'zip', 'rar', '7z', 'tar.gz', 'gz', 'bz2', 'xz', 'deb', 'gif',
    //   'bmp','ico','html','tif','tiff','crdownload','msi'
    // ];
    // const extension = filename.split('.').pop()?.toLowerCase();
    // return extension ? !disallowedExtensions.includes(extension) : false;

    return true;
  }


  checkInactiveRecordState(staticformFields: any) {
    let inactiveControlLableList = [];
    if (staticformFields && staticformFields.length > 0) {
      let singleSelectControls = staticformFields.filter(x => x.CONTROL == "4" || x.CONTROL == "10" || x.CONTROL == "6" || x.CONTROL == "7");
      if (singleSelectControls) {
        singleSelectControls.forEach((item) => {

          if (item.ControlValue && (item.CONTROL == "4" || item.CONTROL == "10") && item.GROUP_VALUES_LIST && item.GROUP_VALUES_LIST.length > 0) {
            let inactiveRec = item.GROUP_VALUES_LIST.filter(x => item.ControlValue.includes(x.value) && x.RECORD_STATE == 0); //&& item.CONTROL == "4" , x.value == item.ControlValue
            if (inactiveRec && inactiveRec.length > 0) {
              if (!inactiveControlLableList.includes(item.LABEL)) {
                let errMesg = "Please remove inactive " + item.LABEL + " to save the details";
                inactiveControlLableList.push(errMesg);
              }
            }
          }
          else {
            if (item.ControlValue) {
              let seletedItem = "";
              let seletedItemList: any = [];
              if (item.SourceItems != undefined) {
                for (let c = 0; c < item.SourceItems.length; c++) {

                  if (seletedItem == "") {
                    seletedItem = item.SourceItems[c].value;
                    seletedItemList.push(item.SourceItems[c])
                  }
                  else {
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                    seletedItemList.push(item.SourceItems[c])

                  }

                }
              }
              // let seletedItemList: any = seletedItem.split(",");
              if (item.CONTROL != 6) {
                let inactiveRec = seletedItemList.filter(x => (item.ControlValue.indexOf(x.value) > -1) && x.RECORD_STATE == 0); //&& item.CONTROL == "4" , x.value == item.ControlValue
                if (inactiveRec && inactiveRec.length > 0) {
                  if (!inactiveControlLableList.includes(item.LABEL)) {
                    let errMesg = "Please remove inactive " + item.LABEL + " to save the details";
                    inactiveControlLableList.push(errMesg);
                  }
                }
              }
              else {
                let inactiveRec = seletedItemList.filter(x => (item.ControlValue == (x.value)) && x.RECORD_STATE == 0); //&& item.CONTROL == "4" , x.value == item.ControlValue
                if (inactiveRec && inactiveRec.length > 0) {
                  if (!inactiveControlLableList.includes(item.LABEL)) {
                    let errMesg = "Please remove inactive " + item.LABEL + " to save the details";
                    inactiveControlLableList.push(errMesg);
                  }
                }
              }


            }

          }
        })
      }
    }
    return inactiveControlLableList;
  }

  checkHasSingleControlValue(staticformFields: any) {
    let valid: boolean = true;
    if (staticformFields && staticformFields.length > 0) {
      staticformFields.forEach((item) => {
        let seletedItem = "";
        if (item.CONTROL == '6') {
          for (let c = 0; c < item.SourceItems.length; c++) {
            if (item.SourceItems[c].Checked == true) {
              if (seletedItem == "")
                seletedItem = item.SourceItems[c].value;
              else
                seletedItem = seletedItem + "," + item.SourceItems[c].value;
            }
          }
          item.ControlValue = seletedItem;
        }

      })
      let singleSelectControls = staticformFields.filter(x => (x.ControlValue != null && x.ControlValue != undefined && x.ControlValue != '') || (x.UploadFiles && x.UploadFiles.length > 0));
      if (!singleSelectControls || singleSelectControls.length == 0) {
        valid = false;
      }
    }
    return valid;
  }

  refreshPage(applicationId) {
    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationId).subscribe(data => {
      this.appId = data.ID;
      this.setISTApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = applicationId;
      this.menudata.formstate = "Draft";
      this.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.dataShare.setApplicationID(applicationId);
      let Url = '/home/ist/my-applications/application-ext/:' + applicationId + '/' + data.FLEX_FIELD_1;
      this.router.navigate([Url], { skipLocationChange: true, queryParams: { id: applicationId, app_ext: true, module: "ist", screen_type: "my-applications" } })
    });
  }

  Save_EAP_APP_Record(staticformFields, Application_Type_ID,Currency_ID) {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(staticformFields));
    uploadData.append("ModuleID", "5");
    uploadData.append("SUBMIT_STATUS", "0");
    uploadData.append("Application_Type_ID", Application_Type_ID);
    uploadData.append("Currency_ID", Currency_ID);
    return this.summaryService.SaveIstGeneralInfo("api/EAPGeneralInfo/Insert", uploadData);
  }

  UploadTempSave(event, ques: SCREEN_CONTROL): Document_Upload_File[] {
    if (ques.UploadFiles == undefined || ques.UploadFiles == null){
      ques.UploadFiles = [];
    }
    for (let i = 0; i < event.target.files.length; i++) {
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
         this.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
      }
      else if (file != null && (ext == 'crdownload')) {
       this.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
      }
      else if (file != null && ((filesize > 524288000))) {
        this.ValidationBanner("Accepts maximum file size 500MB");
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
           return ques.UploadFiles;
        });
      }
    }
     return ques.UploadFiles;
  }
  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

}
